<template>
    <tasks-provider v-slot="{
        campaign,
        proposal,
        proposalStep,
        patchProposalStep,
        goNextStep,
        goPreviousStep,
        isLoading,
        isCompletingProposal,
        errors,
        errorMessage
    }" style="height: 100%">
        <proposal-tasks-view
            :campaign="campaign"
            :proposal-step="proposalStep"
            :proposal="proposal"
            :is-loading="isLoading"
            :errors="errors"
            :error-message="errorMessage"
            :is-completing-proposal="isCompletingProposal"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchProposalStep"
        />
    </tasks-provider>
</template>
<script>
    import ProposalTasksView from "../data-views/proposals/ProposalTasksView";
    import ProposalsProvider from "../providers/ProposalsProvider";
    import TasksProvider from "../providers/proposal-steps/TasksProvider";

    export default {
        name: "ProposalTasksRouterView",
        components: {TasksProvider, ProposalsProvider, ProposalTasksView}
    }
</script>
